const breakpoint = 908

module.exports = {
    breakpoint
}